import { Suspense, lazy, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import { AUTH_ROUTES_PATHS, HF_ROUTES_PATHS, LANDING_ROUTES_PATHS } from '@/config/routes';

import { PrivateRoute } from '@/components/router/PrivateRoute';

import { loadSmartlook } from '@/scripts/smartlook';

import { LOAD_SMARTLOOK_SCRIPTS } from './constants';
import { EActionEvents, trackEvent } from './tracking';

const AuthPage = lazy(() => import('./pages/Auth/AuthPage'));
const LandingPage = lazy(() => import('./pages/Landing/LandingPage'));
const AdminPage = lazy(() => import('./pages/Admin/AdminPage'));

export const App = () => {
  useEffect(() => {
    trackEvent(EActionEvents.openSite);
    if (LOAD_SMARTLOOK_SCRIPTS) {
      loadSmartlook();
    }
  }, []);

  return (
    <Suspense fallback="">
      <Switch>
        <Route path={LANDING_ROUTES_PATHS} exact>
          <LandingPage />
        </Route>

        <Route path={AUTH_ROUTES_PATHS} exact>
          <AuthPage />
        </Route>

        <PrivateRoute path={HF_ROUTES_PATHS} exact>
          <AdminPage />
        </PrivateRoute>
      </Switch>
    </Suspense>
  );
};
